import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'

import { AcknowledgedStatus } from '../../../models'

interface IParams {
  acknowledgedStatus?: AcknowledgedStatus
  excludedField: keyof Pick<
    ISobAnalyticsReportJoined,
    | 'IsExcluded'
    | 'IsExcludedQuarterlyQ1'
    | 'IsExcludedQuarterlyQ2'
    | 'IsExcludedQuarterlyQ3'
    | 'IsExcludedQuarterlyQ4'
    | 'IsExcludedQuarterlyQ1Q2'
    | 'IsExcludedQuarterlyQ1Q2Q3'
    | 'IsExcludedQuarterlyQ3Q4'
    | 'IsExcludedQuarterlyQ1Q2Q3Q4'
  >
  el: ISobAnalyticsReportJoined
}

export const isShowPlanned = ({
  acknowledgedStatus = AcknowledgedStatus.All,
  excludedField,
  el,
}: IParams) => {
  if (acknowledgedStatus === AcknowledgedStatus.Acknowledged) {
    return el[excludedField] == 0 && el.IsAcknowledgedCY == 1
  }
  if (acknowledgedStatus === AcknowledgedStatus.Unacknowledged) {
    return el[excludedField] == 0 && el.IsAcknowledgedCY == 0
  }

  return el[excludedField] == 0
}
